<template>
  <div>
    <el-input class="zwx-input zwx-work-addr-input" v-model="zoneName"
              style="width:455px !important" maxlength="400" placeholder="" @input="workArrChange">
      <el-tooltip slot="suffix" effect="dark" :content="computedPositionTip" placement="top">
        <i class="el-input__icon filled chis-icon-filled-addr work-addr-position" style="cursor: pointer" :style="computedPositionStyle"
           @click="msMapDialogOpen"></i>
      </el-tooltip>
    </el-input>
    <!-- 百度地图弹框组件 -->
    <el-dialog title="选择地点位置" width="838px" height="575px" class="map-dialog-css"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="msBaiduMapForm.mapDialogVisible" @closed="msMapDialogClose()">
      <div class="map-search-input-div">
        <el-input class="ms-map-input" @keyup.enter.native="addressSearchAction()"
                  v-model.trim="msBaiduMapForm.searchAddress" placeholder="搜索位置">
          <i slot="suffix" style="margin-right: 8px;cursor: pointer" class="el-icon-search"
             @click="addressSearchAction()"></i>
        </el-input>
        <div id='search-result-Panel' v-show="msBaiduMapForm.ifShowResultDiv" class='search-result-Panel'>
          <div class="search-result-title">
            <div>共搜索&nbsp;{{ msBaiduMapForm.resultList.length }}&nbsp;记录</div>
            <div>
              <el-button class="zwx-button-text-28" @click="msBaiduMapForm.ifShowResultDiv=false">关闭
              </el-button>
            </div>
          </div>
          <div class='search-result-content'>
            <div @click="showPointInfo(addr)" class="search-result-panel-item"
                 v-for="(addr,index) in msBaiduMapForm.resultList" :key="index">
              <div>{{ addr.title }}</div>
              <div>{{ addr.address }}</div>
            </div>
          </div>
        </div>
      </div>
      <div id="baidMapDialog" class="map-select-div" style="width:100%;height:479px;"></div>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between;"
            v-if="ifFooter">
        <div>
          <slot name="footer"/>
        </div>
        <div style="width: 100%;margin-right: 20px;margin-left: 20px;display: flex;justify-content: space-between">
           <div style="display: flex;align-items: center;">
                <span style="font-size: 13px;color: #475669;">当前坐标：</span>
                <span style="font-size: 15px;font-weight:600;"
                      v-if="msMapFormExp.lng==null||msMapFormExp.lng.length===0">暂无位置信息</span>
                <span style="font-size: 15px;font-weight:600;"
                      v-else>{{ msMapFormExp.lng }}°E，{{ msMapFormExp.lat }}°N</span>
           </div>
           <div>
             <el-button class="zwx-button zwx-button-32" v-if="ifDetermine" type="primary"
                        @click="msMapDialogSubmit()">确定</el-button>
             <el-button class="zwx-button zwx-button-32" v-if="ifCancel" @click="msBaiduMapForm.mapDialogVisible=false">取消</el-button>
           </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: 'BaiduMapDialog',
  model:{
    prop: 'value',
    event: 'propEvent',
  },
  props: {
    lng:{type: Number,default:null},
    lat:{type: Number,default:null},
    fullZoneName:{type: String,default:''},
    value: {type: String, default: ''},
    ifFooter: {type: Boolean, default: true},
    ifDetermine: {type: Boolean, default: true},
    ifCancel: {type: Boolean, default: true},
  },
  data() {
    return {
      zoneName: this.value,
      positionState: 0,//当前定位状态（0：未定位，1：已定位，2：重新修改）
      //返回的地图信息(主要用于存储)
      /*mapInfo: {
        address:'',
        lng:'',
        lat:'',
      },*/
      msBaiduMapForm: {
        searchAddress: '',
        resultList: [],
        ifShowResultDiv: false,
        mapDialogVisible: false,
        overlays: [],//鼠标绘制标注点集合
      },
      msMapFormExp: {
        map: null,
        lat: '',
        lng: '',
        area: '',
        mapDiv: '',
        address: '',
        points: [],
        ply: null,
        marker: [],
        unitName: ''
      }
    }
  },
  watch:{
    value: {
      handler(v) {
        this.zoneName = v
      },
      immediate: true,
      deep: true,
    },
    lng: {
      handler(v) {
        this.msMapFormExp.lng = v
        this.changePositionState()
      },
      immediate: true,
      deep: true,
    },
    lat: {
      handler(v) {
        this.msMapFormExp.lat = v
        this.changePositionState()
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if(this.$zwxBase.verifyIsBlank(this.lng) || this.$zwxBase.verifyIsBlank(this.lat)){
      this.positionState = 0
    } else {
      this.positionState = 1
    }
  },
  mounted() {

  },
  activated() {

  },
  computed: {

    /**
     * 地图标记悬浮文本
     */
    computedPositionTip () {
      let tip = '点击定位';
      if (this.positionState === 2) {
        tip = '重新定位';
      } else if (this.positionState === 1) {
        tip = this.msMapFormExp.lng + '°E' + ',' + this.msMapFormExp.lat + '°N';
      }
      return tip;
    },
    /**
     * 地图标记样式
     */
    computedPositionStyle: function () {
      let styleName = this.positionState === 2 ? 'color: #E02020 !important' : (this.positionState === 1 ? 'color: #37C516 !important' : 'color: #3E71F7 !important');
      return styleName;
    },
  },
  methods: {
    changePositionState(){
      if(this.$zwxBase.verifyIsBlank(this.lng) || this.$zwxBase.verifyIsBlank(this.lat)){
        this.positionState = 0
      } else {
        this.positionState = 1
      }
    },
    /**
     * 打开弹窗
     * */
    msMapDialogOpen: function () {
      if(this.$zwxBase.verifyIsBlank(this.fullZoneName)){
        this.$emit('msNotify', '错误', "请先选择区域", 'error');
        return;
      }
      const searchAddress = this.fullZoneName.replaceAll('_', '')
      var area = this.fullZoneName.split('_').concat();
      area.pop();
      area.join('');
      this.msBaiduMapForm.searchAddress = searchAddress;
      this.msMapFormExp.address = searchAddress;
      this.msMapFormExp.area = area;
      this.msBaiduMapForm.resultList = [];
      this.msBaiduMapForm.ifShowResultDiv = false;
      this.msBaiduMapForm.mapDialogVisible = true;
      this.$nextTick(function () {
        this.msBaiduMapInitWithCover(this.msMapFormExp.lng, this.msMapFormExp.lat, area, true, true, true);
      });
    },
    /**
     * 地图初始化  ifClick：是否有点击事件 ifShowWin：标注点是否显示弹出框
     * */
    msBaiduMapInitWithCover: function (lng, lat, area, ifClick, ifShowWin, cover) {
      let that = this
      that.msMapFormExp.mapDiv = 'baidMapDialog'
      that.msMapFormExp.lat = lat;
      that.msMapFormExp.lng = lng;
      that.msMapFormExp.points = [];
      that.msMapFormExp.map = new window.BMap.Map(that.msMapFormExp.mapDiv, {minZoom: 10, maxZoom: 24})// 创建Map实例
      that.msMapFormExp.map.disableDoubleClickZoom();//去除双击放大功能
      that.msMapFormExp.map.enableScrollWheelZoom(true);
      that.msMapFormExp.map.setDefaultCursor("url('bird.cur')");
      // 设置遮罩层
      if (cover) {
        that.msBaiduMapGetCover(area, this.msMapFormExp.map);
      }
      //实例化鼠标绘制工具
      var drawingManager = new window.BMapLib.DrawingManager(this.msMapFormExp.map, {
        isOpen: false, //是否开启绘制模式
        enableDrawingTool: true, //是否显示工具栏
        drawingToolOptions: {
          anchor: BMAP_ANCHOR_TOP_RIGHT, //位置
          offset: new window.BMap.Size(60, 10), //偏离值
          drawingModes: [BMAP_DRAWING_MARKER]
        }
      });
      //添加右上角控件
      var top_right_navigation = new window.BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        type: BMAP_NAVIGATION_CONTROL_SMALL
      })
      this.msMapFormExp.map.addControl(top_right_navigation);
      //修改提示语句
      document.getElementsByClassName('BMapLib_Drawing')[0].getElementsByClassName('BMapLib_hander')[0].title = '拖拽模式';
      document.getElementsByClassName('BMapLib_Drawing')[0].getElementsByClassName('BMapLib_marker')[0].title = '标点模式';
      //默认选择鼠标拖动按钮
      document.getElementsByClassName('BMapLib_Drawing')[0].getElementsByClassName('BMapLib_hander')[0].click();

      //地图加载完成后事件
      function mapLoad() {
        that.msMapFormExp.map.setZoom(15);
        //标注点
        if (that.$zwxBase.verifyIsNotBlank(lng) && that.$zwxBase.verifyIsNotBlank(lat)) {
          var point = new window.BMap.Point(lng, lat);
          that.msBaiduMapAddMarker(point, that.msBaiduMapForm.searchAddress);
          that.msMapFormExp.map.centerAndZoom(point);
        }
        that.msMapFormExp.map.removeEventListener("tilesloaded", mapLoad);
      }

      that.msMapFormExp.map.addEventListener('tilesloaded', mapLoad);

      //地址搜索（已经选择了坐标不需要调取查询）
      if (that.$zwxBase.verifyIsBlank(lng) || that.$zwxBase.verifyIsBlank(lat)) {
        that.addressSearchAction();
      }
      if (ifClick) {
        //添加鼠标绘制工具监听事件，用于获取绘制结果
        drawingManager.addEventListener('overlaycomplete', function (event) {
          var e = event.overlay;
          //清除所有覆盖物
          that.msBaiduMapForm.overlays.push(e);
          that.msMapDialogClearAllOverlays();
          that.clearMapMarker();
          var point = new window.BMap.Point(e.point.lng, e.point.lat);
          if (!that.msMapFormExp.area) {
            that.$emit('msNotify', '错误', "请先选择区域", 'error');
            return;
          }
          var result = window.BMapLib.GeoUtils.isPointInPolygon(point, that.msMapFormExp.ply);
          if (!result) {
            that.$emit('msNotify', '错误', "您的定位在当前区域外", 'error');
            return;
          }
          var gc = new window.BMap.Geocoder();
          gc.getLocation(point, function (rs) {
            var addComp = rs.addressComponents;
            var addrInfo = (addComp.province === addComp.city ? "" : addComp.province) + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
            that.msMapFormExp.address = addrInfo;
            that.msMapFormExp.lng = parseFloat(e.point.lng.toFixed(6));
            that.msMapFormExp.lat = parseFloat(e.point.lat.toFixed(6));
            that.msBaiduMapAddMarker(point, addrInfo);
          });
        });
      }
    },
    msBaiduMapGetCover: function (area, map) {
      let that = this
      var bdary = new window.BMap.Boundary();
      bdary.get(area, function (rs) {       //获取行政区域
        map.clearOverlays();        //清除地图覆盖物
        var count = rs.boundaries.length; //行政区域的点有多少个
        if (count === 0) {
          this.$emit('msNotify', '错误', "未能获取当前输入行政区域", 'error');
          return;
        }
        //网上查了下，东西经南北纬的范围
        var EN_JW = "180, 90;"; //东北角
        var NW_JW = "-180, 90;"; //西北角
        var WS_JW = "-180, -90;"; //西南角
        var SE_JW = "180, -90;"; //东南角
        //4.添加环形遮罩层
        var ply1 = new window.BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, {
          strokeColor: "none",
          fillColor: "rgb(246,246,246)",
          fillOpacity: 1,
          strokeOpacity: 0.5
        }); //建立多边形覆盖物
        map.addOverlay(ply1);
        //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
        var ply = new window.BMap.Polygon(rs.boundaries[0], {
          strokeWeight: 2,
          strokeColor: "#00f",
          fillColor: ""
        });
        map.addOverlay(ply);
        map.setViewport(ply.getPath()); //调整视野
        that.msMapFormExp.ply = ply;
      });
    },
    /**
     * 地图标注点
     * */
    msBaiduMapAddMarker: function (point, address) {
      this.clearMapMarker();
      var mapIcon = new window.BMap.Icon('img/baidu_map/map-marker.png', new window.BMap.Size(22, 34));
      var mapMarker = new window.BMap.Marker(point, {icon: mapIcon});
      this.msMapFormExp.marker.push(mapMarker);
      this.msMapFormExp.map.addOverlay(mapMarker);
      var label = new window.BMap.Label(address, {offset: new window.BMap.Size(parseInt(address.length / 2) * 13 * -1, -50)});
      label.setStyle({
        color: "#333333",
        fontSize: "14px",
        height: "36px",
        lineHeight: "34px",
        border: "1px solid #CCCCCC",
        padding: "0 10px",
      });
      mapMarker.setLabel(label);
      this.msMapFormExp.points = [];
      this.msMapFormExp.points.push(point);
      this.msMapFormExp.map.panTo(point);
    },
    clearMapMarker: function () {
      for (var i in this.msMapFormExp.marker) {
        this.msMapFormExp.map.removeOverlay(this.msMapFormExp.marker[i]);
      }
      this.msMapFormExp.marker = [];
    },
    showPointInfo: function (result) {
      var point = new window.BMap.Point(result.lng, result.lat);
      var isResultNotifj = window.BMapLib.GeoUtils.isPointInPolygon(point, this.msMapFormExp.ply);
      if (!isResultNotifj) {
        this.$emit('msNotify', '错误', "您的定位在当前区域外", 'error');
        return;
      }
      this.msMapFormExp.lat = parseFloat(result.lat.toFixed(6));
      this.msMapFormExp.lng = parseFloat(result.lng.toFixed(6));
      this.msMapFormExp.address = result.address;
      this.msBaiduMapAddMarker(point, result.address);
    },
    addressSearchAction: function () {
      var that = this
      var options = {
        onSearchComplete(results) {
          that.msBaiduMapForm.resultList = []
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var rs = {};
              rs.title = results.getPoi(i).title;
              rs.lng = results.getPoi(i).point.lng;
              rs.lat = results.getPoi(i).point.lat;
              rs.address = results.getPoi(i).address;
              that.msBaiduMapForm.resultList.push(rs);
            }
          }
          that.msBaiduMapForm.ifShowResultDiv = true
        }
      };
      var local = new window.BMap.LocalSearch(that.msMapFormExp.map, options);
      local.search(that.msBaiduMapForm.searchAddress);
    },
    msMapDialogClose: function () {
      Object.assign(this.msBaiduMapForm, this.$options.data().msBaiduMapForm);
      this.msBaiduMapForm.mapDialogVisible = false;
    },
    /**
     * 触发外部提交方法
     */
    msMapDialogSubmit: function () {
      this.$emit('submit', this.msMapFormExp.lng, this.msMapFormExp.lat, this.msMapFormExp.address);
      if (this.$zwxBase.verifyIsBlank(this.msMapFormExp.lng)
          && this.$zwxBase.verifyIsBlank(this.msMapFormExp.lat)) {
        this.positionState = 0;
      } else {
        this.positionState = 1;
      }
      this.msMapDialogClose();
    },
    /**
     * 清除鼠标绘制所有标注点
     */
    msMapDialogClearAllOverlays: function () {
      var overlays = this.msBaiduMapForm.overlays;
      for (var i in overlays) {
        this.msMapFormExp.map.removeOverlay(overlays[i]);
      }
      this.msBaiduMapForm.overlays.length = 0;
    },
    /**
     * 地址change事件
     */
    workArrChange(value) {
      this.positionState = 0;
      if (this.$zwxBase.verifyIsNotBlank(value)
          && (this.$zwxBase.verifyIsNotBlank(this.msMapFormExp.lat)
              || this.$zwxBase.verifyIsNotBlank(this.msMapFormExp.lng))) {
        this.positionState = 2;
      }
      //双向绑定
      this.$emit('propEvent', value)
    },
  },
}
</script>

<style lang="less" scoped>

</style>

<style lang="less">
.map-search-input-div {
  position: absolute;
  z-index: 999;
  margin-left: 24px;
  margin-top: 20px;
}

.ms-map-input {
  width: 288px;
  height: 32px;
  line-height: 39px;
  opacity: 1;
  padding-left: 10px;
}

.search-result-Panel {
  border: 1px solid #C0C0C0;
  width: 278px;
  background-color: white;
  color: black;
  margin-top: 3px;
  border-radius: 4px;
  margin-left: 10px;
}

.search-result-content {
  height: auto;
  overflow-y: auto;
  max-height: 260px;
}

.search-result-title {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #C0C0C0;
}

.search-result-title > div:first-child {
  float: left;
  margin-left: 16px;
}

.search-result-title > div:last-child {
  float: right;
  margin-right: 10px;
}

.search-result-panel-item {
  text-align: left;
  font-size: 14px;
  display: block;
  cursor: pointer;
  float: left;
  height: 64px;
  width: 100%;
  line-height: 46px;
}

.search-result-panel-item:hover, .search-result-panel-item:active {
  background-color: #f5f8fe;
}

.search-result-panel-item:not(:last-child) {
  border-bottom: 1px solid #C0C0C0;
}

.search-result-panel-item > div:first-child {
  font-size: 12px;
  font-family: Roboto;
  font-weight: 400;
  color: rgba(31, 45, 61, 1);
  height: 40px;
  line-height: 48px;
  width: 240px;
  margin-left: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.search-result-panel-item > div:last-child {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  height: 25px;
  line-height: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 16px;
  width: 240px;
}

.ms-map-search-icon {
  height: 12px;
  width: 12px;
  background-repeat: no-repeat;
  margin-top: -18px;
  margin-left: 266px;
  position: absolute;
  cursor: pointer;
  vertical-align: middle;
}

/*dialog样式*/
.map-dialog-css .el-dialog__header {
  text-align: center;
  border-bottom: 1px solid #D3DCE6;
  background-color: #F5F7FB;
  padding: 0;
  height: 40px;
  line-height: 40px;
}

.map-dialog-css .el-dialog__title {
  font-size: 14px;
}

.map-dialog-css .el-dialog__body {
  padding: 0;
}

.map-dialog-css .el-dialog__footer {
  border-top: 1px solid #D3DCE6;
  padding: 12px 14px;
}

.map-dialog-css .el-dialog__headerbtn {
  top: 11px;
}

.BMap_bubble_content {
  font-size: 14px;
}

/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

div::-webkit-scrollbar-track {
  background: rgba(235, 236, 240, 1.00);
  border-radius: 2px;
}

div::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}

div::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

div::-webkit-scrollbar-corner {
  background: #179a16;
}

/*隐藏百度地图logo*/
.BMap_cpyCtrl {
  display: none;
}

.anchorBL {
  display: none;
}

.map-dialog-css {
  margin-top: -3vh;
}

.map-select-div {
  width: 100%;
  height: 479px;
}

.component-dialog-footer {
  text-align: right;
}

.dialog-footer-left-component {
  font-size: 12px;
  line-height: 32px;
  float: left;
}

.BMapLib_Drawing {
  width: 68px !important;
  height: 32px !important;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px !important;
}

.BMapLib_Drawing_panel {
  width: 100% !important;
  height: 100% !important;
  box-shadow: none !important;
  border: none !important;
}

.BMapLib_Drawing .BMapLib_box {
  width: 34px !important;
  height: 100% !important;
  border: none !important;
  background-image: none;
}

.BMapLib_Drawing .BMapLib_box.BMapLib_marker_hover {
  background: rgba(71, 71, 71, 1) url("./img/icon_positioning_tool_hover.svg") no-repeat center !important;
}

.BMapLib_Drawing .BMapLib_box.BMapLib_marker {
  background: url("./img/icon_positioning_tool.svg") no-repeat center !important;
}

.BMapLib_Drawing .BMapLib_box.BMapLib_hander_hover {
  background: rgba(71, 71, 71, 1) url("./img/icon_hand_tool_hover.svg") no-repeat center;
}

.BMapLib_Drawing .BMapLib_box.BMapLib_hander {
  background: url("./img/icon_hand_tool.svg") no-repeat center;
}

</style>
